import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid mb-5" }
const _hoisted_2 = { class: "row starter-main mt-5 pt-5" }
const _hoisted_3 = { class: "col-12 mb-4 d-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center gap-3" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex gap-2"
}
const _hoisted_7 = {
  key: 0,
  class: "col-12 text-center py-5"
}
const _hoisted_8 = {
  key: 1,
  class: "row g-4"
}
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "card shadow-sm border-0 h-100" }
const _hoisted_11 = { class: "card-body px-4 pb-4" }
const _hoisted_12 = { class: "row g-4" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "fw-medium mb-0" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "fw-medium mb-0" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = {
  class: "fw-bold mb-0 text-dark",
  style: {"font-size":"1.1rem"}
}
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = {
  class: "p-3 bg-light rounded text-dark",
  style: {"white-space":"pre-wrap","line-height":"1.6"}
}
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = { class: "badge bg-secondary font-weight-normal" }
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "small mb-0" }
const _hoisted_25 = {
  key: 0,
  class: "col-12"
}
const _hoisted_26 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "col-lg-4 d-flex" }
const _hoisted_29 = {
  class: "card shadow-sm border-0 sticky-top w-100 mb-0",
  style: {"top":"100px"}
}
const _hoisted_30 = { class: "card-body px-4 pb-4" }
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = { class: "mb-4" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "mb-4" }
const _hoisted_38 = { class: "mb-4" }
const _hoisted_39 = { class: "mb-4" }
const _hoisted_40 = {
  class: "p-3 bg-light rounded text-dark",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_41 = {
  key: 2,
  class: "mt-4 p-3 bg-light rounded border-start border-4 border-info"
}
const _hoisted_42 = { class: "small text-muted mb-0" }
const _hoisted_43 = {
  key: 2,
  class: "col-12 text-center py-5"
}

import { ref, onMounted, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import apiService from "@/services/apiService";
import { formatDate } from "@/composables/FormatDate";
import { toast, Content } from "vue3-toastify";


export default /*@__PURE__*/_defineComponent({
  __name: 'SupportTicketDetail',
  props: {
  id: {
    type: String,
    required: false
  },
  readOnly: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props;

const route = useRoute();
const router = useRouter();
const ticketId = computed(() => props.id || (route.params.id as string));

const ticket = ref<any>(null);
const isLoading = ref(true);
const isUpdating = ref(false);

const isReadOnly = computed(() => props.readOnly || route.query.mode === 'view');

const updateData = ref({
  status: "open",
  priority: "medium",
  admin_reply: ""
});

const fetchTicketDetails = async () => {
  isLoading.value = true;
  try {
    const res = await apiService.getById("/common/support/tickets", ticketId.value);
    ticket.value = res;
    // Pre-fill update form with current values
    updateData.value.status = res.status;
    updateData.value.priority = res.priority;
    updateData.value.admin_reply = res.admin_reply || "";
  } catch (err: any) {
    console.error("Failed to fetch ticket details:", err);
    toast.error("Failed to load ticket details", { theme: "colored" });
  } finally {
    isLoading.value = false;
  }
};

const handleUpdate = async () => {
  isUpdating.value = true;
  try {
    await apiService.put("/common/admin/support/tickets", ticketId.value, updateData.value);
    toast.success("Ticket updated successfully", { theme: "colored" });
    await fetchTicketDetails();
  } catch (err: any) {
    console.error("Failed to update ticket:", err);
    toast.error(err.response?.data?.message || "Failed to update ticket", { theme: "colored" });
  } finally {
    isUpdating.value = false;
  }
};

const goBack = () => {
  if (props.readOnly || route.query.mode === 'view') {
    const basePath = props.readOnly ? '/closed-tickets' : '/open-tickets';
    router.push(basePath);
  } else {
    router.push("/open-tickets");
  }
};

watch(ticketId, () => {
  fetchTicketDetails();
});

const getStatusBadgeClass = (status: string) => {
  const base = "badge px-3 py-2 rounded-pill ";
  switch (status) {
    case 'open': return base + "bg-danger";
    case 'in-progress': return base + "bg-warning text-dark";
    case 'resolved': return base + "bg-success";
    case 'closed': return base + "bg-secondary";
    default: return base + "bg-light text-dark";
  }
};

const getPriorityBadgeClass = (priority: string) => {
  const base = "badge px-3 py-2 rounded-pill ";
  switch (priority) {
    case 'high': return base + "bg-danger";
    case 'medium': return base + "bg-info";
    case 'low': return base + "bg-light text-dark border";
    default: return base + "bg-light text-dark";
  }
};

onMounted(() => {
  fetchTicketDetails();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-secondary btn-sm",
            onClick: goBack
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "fas fa-arrow-left me-1" }, null, -1),
            _createTextVNode(" Back ", -1)
          ]))]),
          _createElementVNode("h4", _hoisted_5, "Ticket #" + _toDisplayString(ticketId.value.slice(-6).toUpperCase()), 1)
        ]),
        (ticket.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", {
                class: _normalizeClass(["font-weight-bold", getStatusBadgeClass(ticket.value.status)])
              }, _toDisplayString(ticket.value.status.toUpperCase()), 3),
              _createElementVNode("span", {
                class: _normalizeClass(["font-weight-bold", getPriorityBadgeClass(ticket.value.priority)])
              }, _toDisplayString(ticket.value.priority.toUpperCase()), 3)
            ]))
          : _createCommentVNode("", true)
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
            ], -1)
          ]))]))
        : (ticket.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header bg-white border-bottom-0 pt-4 px-4" }, [
                    _createElementVNode("h5", { class: "card-title fw-bold text-primary" }, "Ticket Information")
                  ], -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[5] || (_cache[5] = _createElementVNode("label", { class: "small text-muted d-block mb-1" }, "Name", -1)),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(ticket.value.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "small text-muted d-block mb-1" }, "Email", -1)),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(ticket.value.email), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "small text-muted d-block mb-1" }, "Subject", -1)),
                        _createElementVNode("p", _hoisted_18, _toDisplayString(ticket.value.subject), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "small text-muted d-block mb-1" }, "Message", -1)),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(ticket.value.message), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "small text-muted d-block mb-1" }, "Category", -1)),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(ticket.value.category), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "small text-muted d-block mb-1" }, "Created At", -1)),
                        _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(formatDate)(ticket.value.created_at)), 1)
                      ]),
                      (ticket.value.attachments && ticket.value.attachments.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "small text-muted d-block mb-2" }, "Attachments", -1)),
                            _createElementVNode("div", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticket.value.attachments, (file, idx) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  key: idx,
                                  href: file,
                                  target: "_blank",
                                  class: "btn btn-outline-info btn-sm d-inline-flex align-items-center gap-2",
                                  download: ""
                                }, [
                                  _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-paperclip" }, null, -1)),
                                  _createTextVNode(" Attachment " + _toDisplayString(typeof idx === 'number' && idx + 1), 1)
                                ], 8, _hoisted_27))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "card-header bg-white border-bottom-0 pt-4 px-4" }, [
                    _createElementVNode("h5", { class: "card-title fw-bold text-success" }, "Admin Actions")
                  ], -1)),
                  _createElementVNode("div", _hoisted_30, [
                    (!isReadOnly.value)
                      ? (_openBlock(), _createElementBlock("form", {
                          key: 0,
                          onSubmit: _withModifiers(handleUpdate, ["prevent"])
                        }, [
                          _createElementVNode("div", _hoisted_31, [
                            _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label small text-muted" }, "Status", -1)),
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((updateData.value.status) = $event))
                            }, [...(_cache[14] || (_cache[14] = [
                              _createElementVNode("option", { value: "open" }, "Open", -1),
                              _createElementVNode("option", { value: "closed" }, "Closed", -1)
                            ]))], 512), [
                              [_vModelSelect, updateData.value.status]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label small text-muted" }, "Priority", -1)),
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updateData.value.priority) = $event))
                            }, [...(_cache[16] || (_cache[16] = [
                              _createElementVNode("option", { value: "low" }, "Low", -1),
                              _createElementVNode("option", { value: "medium" }, "Medium", -1),
                              _createElementVNode("option", { value: "high" }, "High", -1)
                            ]))], 512), [
                              [_vModelSelect, updateData.value.priority]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label small text-muted" }, "Admin Reply", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              class: "form-control",
                              rows: "6",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((updateData.value.admin_reply) = $event)),
                              placeholder: "Type your response here..."
                            }, null, 512), [
                              [_vModelText, updateData.value.admin_reply]
                            ])
                          ]),
                          _createElementVNode("button", {
                            type: "submit",
                            class: "btn btn-primary w-100 py-2 fw-bold shadow-sm",
                            disabled: isUpdating.value
                          }, [
                            (isUpdating.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_35))
                              : _createCommentVNode("", true),
                            _cache[19] || (_cache[19] = _createTextVNode(" Update Ticket ", -1))
                          ], 8, _hoisted_34)
                        ], 32))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "small text-muted d-block mb-1" }, "Status", -1)),
                            _createElementVNode("span", {
                              class: _normalizeClass(getStatusBadgeClass(ticket.value.status))
                            }, _toDisplayString(ticket.value.status.toUpperCase()), 3)
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "small text-muted d-block mb-1" }, "Priority", -1)),
                            _createElementVNode("span", {
                              class: _normalizeClass(getPriorityBadgeClass(ticket.value.priority))
                            }, _toDisplayString(ticket.value.priority.toUpperCase()), 3)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _cache[22] || (_cache[22] = _createElementVNode("label", { class: "small text-muted d-block mb-1" }, "Admin Reply", -1)),
                            _createElementVNode("div", _hoisted_40, _toDisplayString(ticket.value.admin_reply || 'No reply provided yet.'), 1)
                          ])
                        ])),
                    (ticket.value.replied_at)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", { class: "small text-muted d-block mb-1" }, "Last Replied By", -1)),
                          _cache[24] || (_cache[24] = _createElementVNode("p", { class: "small mb-1 font-weight-bold text-black" }, _toDisplayString('Admin'), -1)),
                          _createElementVNode("p", _hoisted_42, _toDisplayString(_unref(formatDate)(ticket.value.replied_at)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_43, [...(_cache[26] || (_cache[26] = [
              _createElementVNode("h5", { class: "text-muted" }, "Ticket not found or an error occurred.", -1)
            ]))]))
    ])
  ]))
}
}

})